import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/base/Layout';
import AlertContainer from './components/base/AlertContainer';
import ModalContainer from './components/base/ModalContainer';
import LoginPage from './pages/auth/LoginPage';
import RecoveryRequestPage from './pages/auth/RecoveryRequestPage';
import RecoveryPage from './pages/auth/RecoveryPage';
import RegistrationPage from './pages/registration/RegistrationPage';
import RegistrationFormPage from './pages/registration/form/RegistrationFormPage';
import MailPage from './pages/mail/MailPage';
import MailSettingsPage from './pages/mail/MailSettingsPage';
import ForwardingPage from './pages/mail/ForwardingPage';
import OfficePage from './pages/office/OfficePage';
import OfficeAccessPage from './pages/office/OfficeAccessPage';
import MeetingRoomsPage from './pages/office/MeetingRoomsPage';
import MeetingRoomBookingPage from './pages/office/MeetingRoomBookingPage';
import PaymentPage from './pages/payment/PaymentPage';
import PaymentPayPage from './pages/payment/PaymentPayPage';
import TariffPage from './pages/payment/TariffPage';
import ChargesHistoryPage from './pages/payment/ChargesHistoryPage';
import SupportPage from './pages/support/SupportPage';
import ProfilePage from './pages/profile/ProfilePage';

import { TranslationProvider } from './contexts/TranslationContext';
import InstallPromptGate from './components/install-app/InstallPromptGate';
import { IS_KYC_ENABLED } from './api/utils';
import KycDocumentsPage from './pages/kyc/KycDocumentsPage';
import KycSuccessPage from './pages/kyc/KycSuccessPage';
import IdentityVerificationPage from './pages/kyc/IdentityVerificationPage';
import { KYC_ROUTE, KYC_SUCCESS_ROUTE } from './pages/kyc/kycRoutes';

/** Редирект с сохранением GET-параметров (например ?lang=ru). */
function NavigatePreserveSearch({ to, replace }: { to: string; replace?: boolean }) {
    const location = useLocation();
    return <Navigate to={{ pathname: to, search: location.search }} replace={replace} />;
}

function App() {
    return (
        <TranslationProvider>
            <Router>
                <InstallPromptGate>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/registration" element={<RegistrationPage />} />
                        <Route path="/registration/form" element={<RegistrationFormPage />} />
                        <Route path="/registration/complete" element={<RegistrationFormPage />} />
                        <Route path="/recovery/request" element={<RecoveryRequestPage />} />
                        <Route path="/recovery" element={<RecoveryPage />} />
                        <Route path="/kyc/identity" element={<IdentityVerificationPage />} />
                        <Route path="/" element={<NavigatePreserveSearch to="/login" replace />} />
                        <Route
                            path="*"
                            element={
                                <Layout>
                                    <Routes>
                                        <Route path="/mail" element={<MailPage />} />
                                        <Route path="/mail/settings" element={<MailSettingsPage />} />
                                        <Route path="/mail/forwarding" element={<ForwardingPage />} />
                                        <Route path="/office" element={<OfficePage />} />
                                        <Route path="/office/access" element={<OfficeAccessPage />} />
                                        <Route path="/office/meeting-rooms" element={<MeetingRoomsPage />} />
                                        <Route
                                            path="/office/meeting-rooms/booking"
                                            element={<MeetingRoomBookingPage />}
                                        />
                                        <Route
                                            path="/office/coworking"
                                            element={<MeetingRoomsPage roomType="coworking" />}
                                        />
                                        <Route
                                            path="/office/coworking/booking"
                                            element={<MeetingRoomBookingPage />}
                                        />
                                        <Route path="/payment" element={<PaymentPage />} />
                                        <Route path="/payment/pay" element={<PaymentPayPage />} />
                                        <Route path="/payment/tariff" element={<TariffPage />} />
                                        <Route path="/payment/charges" element={<ChargesHistoryPage />} />
                                        <Route path="/support" element={<SupportPage />} />
                                        <Route path="/profile" element={<ProfilePage />} />
                                        {/* KYC доступен по параметру ?kyc=test при загрузке приложения. */}
                                        {IS_KYC_ENABLED && (
                                            <>
                                                <Route path={KYC_ROUTE} element={<KycDocumentsPage />} />
                                                <Route
                                                    path={KYC_SUCCESS_ROUTE}
                                                    element={<KycSuccessPage />}
                                                />
                                            </>
                                        )}
                                        <Route path="*" element={<Navigate to="/mail" replace />} />
                                    </Routes>
                                </Layout>
                            }
                        />
                    </Routes>
                    <AlertContainer />
                    <ModalContainer />
                </InstallPromptGate>
            </Router>
        </TranslationProvider>
    );
}

export default App;
